import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import { chainParityQueryKeys } from './chainParityQueryKeys';

export function useGetChainParityList(dateFrom: string | undefined, dateTo: string | undefined) {
  return useQuery({
    queryKey: chainParityQueryKeys.list(dateFrom ?? '', dateTo ?? ''),
    queryFn: async ({ signal }) => {
      if (!dateFrom || !dateTo) {
        throw new Error('Chain parity list requires dateFrom and dateTo');
      }
      const res = await PriceParrotService.getParityTrendChains({ date_from: dateFrom, date_to: dateTo }, signal);
      return res.data;
    },
    enabled: Boolean(dateFrom && dateTo),
  });
}
